import { DatasetPlaceholder } from "~/pages/manifold-nextgen/components/datasets/DatasetPlaceholder";

export const DatasetDashboards = () => <DatasetPlaceholder label="Dashboards" />;
